module.exports = __webpack_public_path__ + "static/media/C016.dcfee731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C016.jpg
// module id = 299
// module chunks = 0